import { useTranslation } from 'react-i18next';
import type { IssueSeverity } from '@/types/issue-notice';
import { SEVERITY_META } from './issue-notice-meta';
import { cn } from '@/utils/cn';

interface Props {
  severity: IssueSeverity;
  className?: string;
  /** Icon only on very narrow layouts; label stays available to screen readers. */
  compact?: boolean;
}

export function IssueSeverityBadge({ severity, className, compact }: Props) {
  const { t } = useTranslation();
  const { Icon, fg, bg } = SEVERITY_META[severity];
  const label = t(`issues.severity.${severity}`);
  return (
    <span
      className={cn('inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[12px] font-semibold whitespace-nowrap', className)}
      style={{ color: fg, backgroundColor: bg }}
    >
      <Icon size={14} aria-hidden />
      {compact ? <span className="sr-only">{label}</span> : label}
    </span>
  );
}
